import request from "./../utils/request";

export function listChannels(includeDeleted = false) {
    return request({
        url: includeDeleted ? "/channel/list?includeDeleted=true" : "/channel/list",
        method: "get",
        params: {},
    });
}

export const CHANNEL_API = {
    listChannels,
};

export function createChannel(
    type,
    name,
    payload,
    visibility = {
        users: [],
        departments: [],
    },
    forward,
    commentForward,
    owner
) {
    return request({
        url: "/channel",
        method: "put",
        data: {
            type,
            name,
            forward,
            commentForward,
            payload,
            visibility,
            owner,
        },
    });
}

export function updateChannel(
    id,
    name,
    enabled,
    payload,
    visibility = {
        users: [],
        departments: [],
    },
    forward,
    commentForward,
    zohoForward
) {
    if (forward) {
        if (forward.mode === "live" && !!forward.story) {
            forward.mode = "chatbot";
        } else if (forward.mode !== "live" && !forward.story) {
            forward.mode = "live";
        }
    }

    return request({
        url: `/channel/${id}`,
        method: "post",
        data: {
            name,
            enabled,
            payload,
            visibility,
            forward,
            commentForward,
            zohoForward,
        },
    });
}

export function deleteChannel(id) {
    return request.delete(`/channel/${id}`);
}

export function getTeamGramPipelines(id) {
    return request.get(`/channel/${id}/teamgram-pipelines`);
}
